import commonEnTranslation from '@cd3p/core/assets/en.json';
import commonEsTranslation from '@cd3p/core/assets/es.json';
import commonFrTranslation from '@cd3p/core/assets/fr-CA.json';
import enTranslation from 'assets/en.json';
import esTranslation from 'assets/es.json';
import frTranslation from 'assets/fr-CA.json';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const resources = {
  'en-US': {
    translation: {
      ...commonEnTranslation,
      ...enTranslation,
    },
  },
  es: {
    translation: {
      ...commonEsTranslation,
      ...esTranslation,
    },
  },
  'fr-CA': {
    translation: {
      ...commonFrTranslation,
      ...frTranslation,
    },
  },
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    resources,
    debug: process.env.I18N_DEBUG === 'true',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      caches: [],
    },
  });

export default i18next;
